import { useQuery } from '@tanstack/react-query';
import { getScanbotSdk } from '~/lib/scanbot-client';
import { Page } from '../_screens/ScreenController';

/**
 * Used in Review Screens (ReviewConsumer & ReviewDashboard)
 */
export default function ImagePreview({
  p,
  idx
}: {
  p: Page;
  idx: number;
}): JSX.Element {
  const { data: url } = useQuery({
    queryKey: ['review-image', p.id],
    queryFn: async () => {
      if (!p.capture) {
        return;
      }

      const sdk = await getScanbotSdk();
      const jpeg = await sdk.imageToJpeg(p.capture);
      const blob = new Blob([jpeg], { type: 'image/jpeg' });
      const url = URL.createObjectURL(blob);
      return url;
    }
  });

  return (
    <div
      key={idx}
      className="
          relative w-screen min-w-full h-full snap-center 
          flex items-center justify-center px-spacing-03
        "
    >
      <div className="w-full max-w-[90%] aspect-[1/1.414]">
        {url && (
          <img
            draggable={false}
            src={url}
            alt={`Page ${idx + 1}`}
            className="w-full h-full object-contain"
          />
        )}
      </div>
    </div>
  );
}
